<div class="table-container">

    <!-- ── Header ─────────────────────────────────────────────────── -->
    <div class="panel-header">
        <div class="panel-header__titles">
            <span class="panel-header__eyebrow">System</span>
            <h2 class="panel-header__org">Superadmin Dashboard</h2>
        </div>

    </div>

    <mat-tab-group mat-stretch-tabs="false" style="margin-top: 1rem;" [(selectedIndex)]="selectedTabIndex">
        <!-- ══════════════════════════════════════════════════════════
     TAB 5 — ALL USERS
═══════════════════════════════════════════════════════════ -->
        <mat-tab label="All Users">
            <div class="tab-content">

                <div class="section-header">
                    <span class="section-header__title">All Users</span>
                </div>
                <p class="section-desc">
                    All registered accounts regardless of organization or permission status.
                    You can deactivate accounts to prevent login without deleting them, or permanently delete
                    an account and all its permissions.
                </p>
                <div class="actions-bar" style="padding: 0.75rem 0; gap: 0.75rem;">
                    <button mat-raised-button color="primary" (click)="onInviteUser()">
                        <mat-icon>person_add</mat-icon> Invite New User
                    </button>



                </div>
                <!-- Search -->
                <div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 0.5rem;">
                    <mat-form-field appearance="fill" class="filter-field">
                        <mat-label>Search users</mat-label>
                        <input matInput [(ngModel)]="allUsersSearch" placeholder="e.g. Name, Mail" />
                    </mat-form-field>
                    <span class="example-spacer"></span>
                    <button mat-icon-button matTooltip="Reload" (click)="loadAllUsers()" [disabled]="loadingAllUsers">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>


                <div class="loading-wrapper" *ngIf="loadingAllUsers">
                    <mat-spinner diameter="36"></mat-spinner>
                </div>

                <div class="table-wrapper" *ngIf="!loadingAllUsers">
                    <table class="perm-grid ticket-table">
                        <thead>
                            <tr>
                                <th class="perm-grid__user-col">User</th>
                                <th>Status</th>
                                <th>Created</th>
                                <th>Organizations</th>
                                <th style="width:100%;"></th>
                                <th style="text-align:right; white-space:nowrap;">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let user of filteredAllUsers" class="perm-grid__row">
                                <td class="perm-grid__user-cell">
                                    <div class="perm-grid__user-info">
                                        <div class="avatar" [style.opacity]="user.usr_active ? '0.7' : '0.3'">
                                            {{ user.usr_name.charAt(0).toUpperCase() }}
                                        </div>
                                        <div class="perm-grid__user-details">
                                            <span class="perm-grid__user-name"
                                                [style.opacity]="user.usr_active ? '1' : '0.45'">
                                                {{ user.usr_name }}
                                            </span>
                                            <span class="perm-grid__user-mail">{{ user.usr_mail }}</span>

                                        </div>
                                    </div>
                                </td>
                                <td class="perm-grid__user-status">
                                    <span class="perm-tag" [class.perm-tag--pending]="!user.usr_active"
                                        style="width: fit-content;">
                                        {{ user.usr_active ? 'Active' : 'Inactive' }}
                                    </span>
                                </td>
                                <td class="perm-grid__user-cell"
                                    style="opacity:0.55; font-size:0.8rem; white-space:nowrap;">
                                    {{ user.createdAt | date:'mediumDate' }}
                                </td>
                                <td class="perm-grid__user-cell">
                                    <div class="chip-row">
                                        <span *ngFor="let org of user.organizations" class="perm-tag"
                                            style="cursor:pointer;"
                                            (click)="navigateToOrg(org.id); $event.stopPropagation()">
                                            {{ org.org_name }}
                                        </span>
                                        <span *ngIf="user.organizations.length === 0"
                                            style="opacity:0.4; font-size:0.8rem;">
                                            No organization
                                        </span>
                                    </div>
                                </td>

                                <td style="width:100%;"></td>
                                <td class="perm-grid__user-cell" style="text-align:right; white-space:nowrap;">
                                    <button mat-icon-button
                                        [matTooltip]="user.usr_active ? 'Deactivate user' : 'Activate user'"
                                        (click)="toggleUserActive(user)" [disabled]="togglingUserId === user.usr_id">
                                        <mat-spinner *ngIf="togglingUserId === user.usr_id" diameter="18"></mat-spinner>
                                        <mat-icon *ngIf="togglingUserId !== user.usr_id">
                                            {{ user.usr_active ? 'person_off' : 'person' }}
                                        </mat-icon>
                                    </button>
                                    <button mat-icon-button matTooltip="Delete user permanently" class="delete-btn"
                                        (click)="deleteAllUser(user)">
                                        <mat-icon>delete_outline</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="filteredAllUsers.length === 0" style="width: 100%; padding: 1.5rem 0;">
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <mat-icon color="primary"
                                style="transform:scale(2); margin-bottom:10px;">people_outline</mat-icon>
                            <div>No users found</div>
                        </div>
                    </div>
                </div>

            </div>
        </mat-tab>
        <!-- ══════════════════════════════════════════════════════════
         TAB 1 — ORGANIZATIONS
    ═══════════════════════════════════════════════════════════ -->
        <mat-tab label="Organizations">
            <div class="tab-content">

                <!-- Org list -->
                <div class="section-header" style="margin-top: 0.25rem;">
                    <span class="section-header__title">All Organizations</span>

                </div>
                <p class="section-desc">
                    This is a list of all organizations. You can invite new users or add existing users to an
                    organization. You can set or revoke permissions of specific users within an organization or delete
                    the organization.
                </p>


                <div class="actions-bar" style="padding: 0.75rem 0; gap: 0.75rem;">
                    <button mat-raised-button color="primary" (click)="onCreateOrganization()">
                        <mat-icon>add</mat-icon> New Organization
                    </button>
                </div>
                <!-- Search -->
                <div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 0.5rem;">
                    <mat-form-field appearance="fill" class="filter-field">
                        <mat-label>Search organizations</mat-label>
                        <input matInput [(ngModel)]="allOrganizationSearch" (ngModelChange)="applyOrganizationSearch()"
                            placeholder="Name" />
                    </mat-form-field>
                    <span class="example-spacer"></span>
                    <button mat-icon-button matTooltip="Reload" (click)="loadOrganizations()" [disabled]="loadingOrgs">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>

                <div class="loading-wrapper" *ngIf="loadingOrgs">
                    <mat-spinner diameter="36"></mat-spinner>
                </div>

                <div class="table-wrapper" *ngIf="!loadingOrgs">
                    <table class="perm-grid ticket-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Organization</th>
                                <th>Created</th>
                                <th style="text-align:right;">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let org of filteredOrganizations">
                                <tr class="perm-grid__row" style="cursor:pointer;" (click)="toggleOrg(org)">

                                    <!-- Tiny expand arrow column -->
                                    <td style="width: 32px; padding: 0 0 0 0.5rem;">
                                        <mat-icon
                                            style="opacity:0.4; vertical-align:middle; transition: transform 0.2s;"
                                            [style.transform]="expandedOrgId === org.id ? 'rotate(180deg)' : 'rotate(0)'">
                                            expand_more
                                        </mat-icon>
                                    </td>

                                    <!-- Org name — takes up remaining space -->
                                    <td class="perm-grid__user-cell">
                                        <div class="perm-grid__user-info">
                                            <div class="avatar">{{ org.org_name.charAt(0).toUpperCase() }}</div>
                                            <span class="perm-grid__user-name">{{ org.org_name }}</span>
                                        </div>
                                    </td>

                                    <!-- Date -->
                                    <td class="perm-grid__user-cell"
                                        style="opacity:0.55; font-size:0.8rem; white-space: nowrap; width: 100%;">
                                        {{ org.createdAt | date:'mediumDate' }}
                                    </td>

                                    <!-- Actions pushed right -->
                                    <td style="text-align: right; white-space: nowrap; padding-right: 0.5rem;"
                                        (click)="$event.stopPropagation()">

                                        <button mat-icon-button matTooltip="Invite New User"
                                            (click)="onInviteUserForOrg(org); $event.stopPropagation()">
                                            <mat-icon>person_add</mat-icon>
                                        </button>

                                        <button mat-icon-button matTooltip="Add Existing User"
                                            (click)="onAddExistingUser(org); $event.stopPropagation()">
                                            <mat-icon>person_search</mat-icon>
                                        </button>


                                        <span matTooltip="Delete organization">
                                            <button mat-icon-button (click)="deleteOrganization(org)"
                                                class="delete-btn">
                                                <mat-icon>delete_outline</mat-icon>
                                            </button>
                                        </span>


                                    </td>

                                </tr>

                                <tr *ngIf="expandedOrgId === org.id">
                                    <td [colSpan]="4" style="padding: 0.75rem 1rem 1rem; overflow: hidden;">

                                        <div class="loading-wrapper" *ngIf="loadingOrgId === org.id"
                                            style="padding: 1.5rem 0;">
                                            <mat-spinner diameter="30"></mat-spinner>
                                        </div>

                                        <div *ngIf="loadingOrgId !== org.id && orgRows[org.id]" class="assign-panel">

                                            <!-- Header -->
                                            <div class="assign-panel__header">
                                                <mat-icon>group</mat-icon>
                                                <span>Users in <strong>{{ org.org_name }}</strong></span>

                                                <!-- Actions inline in header -->
                                                <div
                                                    style="margin-left: auto; display: flex; align-items: center; gap: 0.75rem;">



                                                    <button mat-raised-button color="primary"
                                                        (click)="submitOrgChanges(org.id); $event.stopPropagation()"
                                                        [disabled]="!hasOrgPendingChanges(org.id) || savingOrgId === org.id">
                                                        <mat-spinner *ngIf="savingOrgId === org.id" diameter="18"
                                                            style="display:inline-flex; margin-right:6px;"></mat-spinner>
                                                        <mat-icon *ngIf="savingOrgId !== org.id">save</mat-icon>
                                                        {{ savingOrgId === org.id ? 'Saving…' : 'Update Permissions' }}
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Permission grid — overflow scoped here only -->
                                            <div style="overflow-x: auto; margin-top: 0.75rem; max-width: 100%;">

                                                <table class="perm-grid ticket-table">
                                                    <thead>
                                                        <tr>
                                                            <th class="perm-grid__user-col">User</th>
                                                            <ng-container
                                                                *ngFor="let perm of orgPermissions; let i = index">

                                                                <th class="perm-grid__perm-col" [matTooltip]="perm.key"
                                                                    matTooltipPosition="above">
                                                                    {{ perm.label }}
                                                                </th>
                                                            </ng-container>
                                                            <th></th>
                                                        </tr>
                                                    </thead>

                                                    <tbody *ngIf="orgRows[org.id].length != 0">
                                                        <tr *ngFor="let row of orgRows[org.id]" class="perm-grid__row">
                                                            <td class="perm-grid__user-cell">
                                                                <div class="perm-grid__user-info">
                                                                    <div class="avatar">{{
                                                                        row.usr_name.charAt(0).toUpperCase() }}</div>
                                                                    <div class="perm-grid__user-details">
                                                                        <span class="perm-grid__user-name">{{
                                                                            row.usr_name }}</span>
                                                                        <span class="perm-grid__user-mail">{{
                                                                            row.usr_mail }}</span>
                                                                    </div>


                                                                </div>
                                                            </td>
                                                            <ng-container
                                                                *ngFor="let perm of orgPermissions; let i = index">

                                                                <td class="perm-grid__perm-cell"
                                                                    [class.perm-grid__perm-cell--changed]="row.draft[perm.key] !== row.original[perm.key].checked">
                                                                    <mat-checkbox [(ngModel)]="row.draft[perm.key]"
                                                                        color="primary"></mat-checkbox>
                                                                    <span
                                                                        *ngIf="row.draft[perm.key] !== row.original[perm.key].checked"
                                                                        class="perm-grid__dirty-dot"
                                                                        matTooltip="Unsaved change"
                                                                        matTooltipPosition="above">
                                                                    </span>
                                                                </td>
                                                            </ng-container>
                                                            <td class="perm-grid__perm-cell">
                                                                <button mat-icon-button class="perm-grid__delete-btn"
                                                                    matTooltip="Remove user from organization"
                                                                    (click)="removeUserFromOrg(org.id, row); $event.stopPropagation()">
                                                                    <mat-icon>person_remove</mat-icon>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="orgRows[org.id]?.length === 0">
                                                            <td [colSpan]="orgPermissions.length + 1"
                                                                class="loading-wrapper"
                                                                style="padding: 1.5rem 0; text-align: center">
                                                                <mat-icon color="primary"
                                                                    style="transform:scale(1.5); margin-bottom:8px;">people_outline</mat-icon>
                                                                <div>No users in this organization</div>
                                                            </td>
                                                        </tr>
                                                    </tbody>




                                                </table>

                                                <div *ngIf="orgRows[org.id].length == 0"
                                                    style="width: 100%; padding: 1.5rem 0;">
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center;">
                                                        <mat-icon color="primary"
                                                            style="transform:scale(1.5); margin-bottom:8px;">people_outline</mat-icon>
                                                        <div>No users in this organization</div>
                                                    </div>
                                                </div>

                                                <div class="panel-footer" style="margin-top: 5px; margin-left: 5px;">


                                                    <span class="panel-footer__hint"
                                                        *ngIf="hasOrgPendingChanges(org.id)">
                                                        Unsaved changes
                                                    </span>
                                                    <span class="panel-footer__hint panel-footer__hint--none"
                                                        *ngIf="!hasOrgPendingChanges(org.id)">
                                                        No pending changes
                                                    </span>

                                                </div>
                                            </div>

                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>

            </div>
        </mat-tab>

        <!-- ══════════════════════════════════════════════════════════
         TAB 2 — GLOBAL USERS
    ═══════════════════════════════════════════════════════════ -->
        <mat-tab label="Global Permissions">
            <div class="tab-content">

                <div class="section-header">
                    <span class="section-header__title">Users with Global Permissions</span>
                    <span class="example-spacer"></span>

                </div>
                <p class="section-desc">
                    These users have permissions that are not bound to any organization.
                    You can set or revoke individual permissions, add a new user to have system wide permissions or
                    assign a user to an organization.
                </p>

                <!-- Actions bar -->
                <div class="actions-bar" style="padding: 0.75rem 0; gap: 0.75rem;">

                    <button mat-button (click)="submitGlobalChanges()"
                        [disabled]="!hasAnyGlobalPendingChanges() || savingGlobal">
                        <mat-spinner *ngIf="savingGlobal" diameter="18"
                            style="display:inline-flex; margin-right:6px;"></mat-spinner>
                        <mat-icon *ngIf="!savingGlobal">save</mat-icon> {{ savingGlobal ? 'Saving…' : 'Update Permissions' }}
                    </button>
                    <!-- REPLACE the toggleAddGlobalPanel button with: -->
                    <button mat-raised-button color="primary" (click)="onAddGlobalPermission()">
                        <mat-icon>person_search</mat-icon> Grant Global Permissions
                    </button>

                </div>
                <!-- Search -->
                <div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 0.5rem;">
                    <mat-form-field appearance="fill" class="filter-field">
                        <mat-label>Search users</mat-label>
                        <input matInput [(ngModel)]="allGlobalPermissionUserSearch"
                            (ngModelChange)="applyallGlobalPermissionUserSearchSearch()" placeholder="Name" />
                    </mat-form-field>
                    <span class="example-spacer"></span>

                    <button mat-icon-button matTooltip="Reload" (click)="loadGlobalUsers()" [disabled]="loadingGlobal">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>

                <div class="loading-wrapper" *ngIf="loadingGlobal">
                    <mat-spinner diameter="36"></mat-spinner>
                </div>

                <div *ngIf="!loadingGlobal">



                    <!-- Add global permission panel -->
                    <div class="assign-panel" *ngIf="addGlobalPanelOpen" style="margin-bottom: 1rem;">
                        <div class="assign-panel__header">
                            <mat-icon>manage_accounts</mat-icon>
                            <span>Grant global permissions to a user</span>
                            <button mat-icon-button (click)="toggleAddGlobalPanel()" style="margin-left:auto;">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>

                        <!-- User search -->
                        <div style="display:flex; gap: 0.75rem; margin-top: 0.75rem; align-items: flex-start;">
                            <mat-form-field appearance="fill" style="flex:1;">
                                <mat-label>Search user by name or email</mat-label>
                                <input matInput [(ngModel)]="globalUserSearch" (ngModelChange)="searchGlobalUsers()"
                                    placeholder="e.g. John, john@example.com" />
                            </mat-form-field>
                        </div>

                        <!-- Search results -->
                        <div *ngIf="globalUserSearchResults.length > 0" style="margin-bottom: 0.75rem;">
                            <div class="assign-panel__perms-label">Select user</div>
                            <table class="perm-grid ticket-table" style="margin-top: 0.5rem;">
                                <tbody>
                                    <tr *ngFor="let u of globalUserSearchResults" class="perm-grid__row"
                                        style="cursor:pointer;"
                                        [style.background]="selectedGlobalUserId === u.usr_id ? 'rgba(99,102,241,0.08)' : ''"
                                        (click)="selectedGlobalUserId = u.usr_id">
                                        <td class="perm-grid__user-cell">
                                            <div class="perm-grid__user-info">
                                                <div class="avatar">{{ u.usr_name.charAt(0).toUpperCase() }}</div>
                                                <div class="perm-grid__user-details">
                                                    <span class="perm-grid__user-name">{{ u.usr_name }}</span>
                                                    <span class="perm-grid__user-mail">{{ u.usr_mail }}</span>
                                                </div>
                                                <mat-icon *ngIf="selectedGlobalUserId === u.usr_id"
                                                    style="margin-left:auto; color: #6366f1;">check_circle</mat-icon>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Permission selection -->
                        <div>
                            <div class="assign-panel__perms-label">Permissions to grant</div>
                            <div class="invite-perms-grid" style="margin-top: 0.5rem;">
                                <div *ngFor="let perm of globalPermissions" class="perm-chip"
                                    [class.perm-chip--selected]="selectedGlobalPermIds.has(perm.id)" (click)="selectedGlobalPermIds.has(perm.id)
                ? selectedGlobalPermIds.delete(perm.id)
                : selectedGlobalPermIds.add(perm.id)">
                                    <mat-icon class="perm-chip__icon">
                                        {{ selectedGlobalPermIds.has(perm.id) ? 'check_circle' :
                                        'radio_button_unchecked' }}
                                    </mat-icon>
                                    {{ perm.mpm_type.replace('.', ' ') }}
                                </div>
                            </div>
                        </div>

                        <div class="assign-panel__actions">
                            <button mat-button (click)="toggleAddGlobalPanel()">Cancel</button>
                            <button mat-raised-button color="primary" (click)="confirmAddGlobalPermissions()"
                                [disabled]="!selectedGlobalUserId || selectedGlobalPermIds.size === 0">
                                <mat-icon>check</mat-icon> Grant Permissions
                            </button>
                        </div>
                    </div>
                    <div class="table-wrapper">
                        <table class="perm-grid ticket-table">
                            <thead>
                                <tr>
                                    <th class="perm-grid__user-col">User</th>
                                    <th>Created</th>
                                    <ng-container *ngFor="let perm of globalPermissions">
                                        <th class="perm-grid__perm-col" [matTooltip]="perm.mpm_type"
                                            matTooltipPosition="above">
                                            {{ perm.mpm_type.replace('.', ' ') }}
                                        </th>
                                    </ng-container>
                                    <th style="width: 100%;"></th> <!-- spacer -->
                                    <th style="text-align:right; white-space:nowrap;">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let user of filteredGlobalUsers" class="perm-grid__row">
                                    <td class="perm-grid__user-cell">
                                        <div class="perm-grid__user-info">
                                            <div class="avatar">{{ user.usr_name.charAt(0).toUpperCase() }}</div>
                                            <div class="perm-grid__user-details">
                                                <span class="perm-grid__user-name">{{ user.usr_name }}</span>
                                                <span class="perm-grid__user-mail">{{ user.usr_mail }}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="perm-grid__user-cell" style="opacity:0.55; font-size:0.8rem;">
                                        {{ user.createdAt | date:'mediumDate' }}
                                    </td>
                                    <ng-container *ngFor="let perm of globalPermissions">
                                        <td class="perm-grid__perm-cell"
                                            [class.perm-grid__perm-cell--changed]="hasGlobalPermChange(user, perm.id)">
                                            <mat-checkbox [checked]="userHasGlobalPerm(user, perm.id)"
                                                (change)="toggleGlobalPerm(user, perm.id, $event.checked)"
                                                color="primary">
                                            </mat-checkbox>
                                            <span *ngIf="hasGlobalPermChange(user, perm.id)"
                                                class="perm-grid__dirty-dot" matTooltip="Unsaved change"
                                                matTooltipPosition="above">
                                            </span>
                                        </td>
                                    </ng-container>
                                    <td style="width: 100%;"></td> <!-- spacer -->
                                    <td class="perm-grid__user-cell" style="text-align:right; white-space:nowrap;">
                                        <button mat-icon-button matTooltip="Strip all global permissions"
                                            class="delete-btn" (click)="revokeAllGlobalPermissions(user)">
                                            <mat-icon>remove_moderator</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="globalUsers.length === 0">
                                    <td [colSpan]="globalPermissions.length + 3" class="loading-wrapper"
                                        style="padding: 2rem 0;">
                                        <mat-icon color="primary"
                                            style="transform:scale(2); margin-bottom:10px;">manage_accounts</mat-icon>
                                        <div>No global users</div>
                                    </td>
                                </tr>
                            </tbody>


                        </table>

                    </div>
                    <div class="panel-footer" style="margin-top: 5px; margin-left: 5px; width:99%;">


                        <span class="panel-footer__hint" *ngIf="hasAnyGlobalPendingChanges()">
                            Unsaved changes
                        </span>
                        <span class="panel-footer__hint panel-footer__hint--none" *ngIf="!hasAnyGlobalPendingChanges()">
                            No pending changes
                        </span>
                    </div>
                </div>

            </div>
        </mat-tab>


        <!-- ══════════════════════════════════════════════════════════
     TAB 3 — DANGLING USERS
═══════════════════════════════════════════════════════════ -->
        <mat-tab label="Dangling Users">
            <div class="tab-content">

                <div class="section-header">
                    <span class="section-header__title">Users Without Any Permissions</span>
                    <span class="example-spacer"></span>
                    <button mat-icon-button matTooltip="Reload" (click)="loadDanglingUsers()"
                        [disabled]="loadingDangling">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
                <p class="section-desc">
                    These users have no permissions assigned — neither org-scoped nor global.
                    They can log in but cannot do anything. Assign them to an organization to grant access.
                </p>

                <div class="loading-wrapper" *ngIf="loadingDangling">
                    <mat-spinner diameter="36"></mat-spinner>
                </div>

                <div *ngIf="!loadingDangling">

                    <div class="assign-panel" *ngIf="assigningUser">
                        <div class="assign-panel__header">
                            <mat-icon>person_pin</mat-icon>
                            <span>Assign <strong>{{ assigningUser.usr_name }}</strong> to an organization</span>
                            <button mat-icon-button (click)="cancelAssign()" style="margin-left:auto;">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>

                        <mat-form-field appearance="fill" style="width:100%; margin-top:0.75rem;">
                            <mat-label>Target organization</mat-label>
                            <mat-select [(ngModel)]="selectedOrgId" (ngModelChange)="onAssignOrgChange()">
                                <mat-option *ngFor="let org of organizations" [value]="org.id">
                                    {{ org.org_name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div *ngIf="selectedOrgId" class="assign-perm-grid">
                            <div class="assign-panel__perms-label">Permissions in {{ getOrgName(selectedOrgId) }}</div>
                            <table class="perm-grid ticket-table" style="margin-top: 0.5rem;">
                                <thead>
                                    <tr>
                                        <th>Permission</th>
                                        <th style="text-align:center;">Grant</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let perm of masterPermissions; let i = index">
                                        <tr
                                            *ngIf="i > 0 && perm.mpm_type.split('.')[0] !== masterPermissions[i-1].mpm_type.split('.')[0]">
                                            <td colspan="2"
                                                style="height:1px; padding:0; background-color: rgba(0,0,0,0.12);"></td>
                                        </tr>
                                        <tr class="perm-grid__row">
                                            <td class="perm-grid__user-cell">
                                                <span class="perm-grid__user-name">{{ perm.mpm_type.replace('.', ' ')
                                                    }}</span>
                                            </td>
                                            <td class="perm-grid__perm-cell"
                                                [class.perm-grid__perm-cell--changed]="selectedPermissionIds.has(perm.id)">
                                                <mat-checkbox [checked]="selectedPermissionIds.has(perm.id)"
                                                    (change)="toggleAssignPermission(perm.id)" color="primary">
                                                </mat-checkbox>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>

                        <div class="assign-panel__actions">
                            <button mat-button (click)="cancelAssign()">Cancel</button>
                            <button mat-raised-button color="primary" (click)="confirmAssign()"
                                [disabled]="!selectedOrgId || selectedPermissionIds.size === 0 || assignSaving">
                                <mat-spinner *ngIf="assignSaving" diameter="18"
                                    style="display:inline-flex; margin-right:6px;"></mat-spinner>
                                <mat-icon *ngIf="!assignSaving">check</mat-icon>
                                {{ assignSaving ? 'Assigning…' : 'Confirm Assignment' }}
                            </button>
                        </div>
                    </div>

                    <div class="table-wrapper">
                        <table class="perm-grid ticket-table">
                            <thead>
                                <tr>
                                    <th class="perm-grid__user-col">User</th>
                                    <th>Created</th>
                                    <th style="width:100%;"></th>
                                    <th style="text-align:right; white-space:nowrap;">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let user of danglingUsers" class="perm-grid__row">
                                    <td class="perm-grid__user-cell">
                                        <div class="perm-grid__user-info">
                                            <div class="avatar">{{ user.usr_name.charAt(0).toUpperCase() }}</div>
                                            <div class="perm-grid__user-details">
                                                <span class="perm-grid__user-name">{{ user.usr_name }}</span>
                                                <span class="perm-grid__user-mail">{{ user.usr_mail }}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="perm-grid__user-cell"
                                        style="opacity:0.55; font-size:0.8rem; white-space:nowrap;">
                                        {{ user.createdAt | date:'mediumDate' }}
                                    </td>
                                    <td style="width:100%;"></td>
                                    <td class="perm-grid__user-cell" style="text-align:right; white-space:nowrap;">
                                        <button mat-icon-button matTooltip="Assign to organization"
                                            (click)="startAssign(user)"
                                            [class.assign-active]="assigningUser?.usr_id === user.usr_id">
                                            <mat-icon>person_pin</mat-icon>
                                        </button>
                                        <button mat-icon-button matTooltip="Delete user permanently" class="delete-btn"
                                            (click)="deleteUser(user)">
                                            <mat-icon>delete_outline</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="danglingUsers.length === 0" style="width: 100%; padding: 1.5rem 0;">
                            <div style="display: flex; flex-direction: column; align-items: center;">
                                <mat-icon color="primary"
                                    style="transform:scale(2); margin-bottom:10px;">how_to_reg</mat-icon>
                                <div>No dangling users — all accounts have permissions</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </mat-tab>

        <!-- ══════════════════════════════════════════════════════════
     TAB 4 — PENDING INVITES
═══════════════════════════════════════════════════════════ -->
        <mat-tab label="Pending Invites">
            <div class="tab-content">

                <div class="section-header">
                    <span class="section-header__title">Unaccepted Invitations</span>
                    <span class="example-spacer"></span>
                    <button mat-icon-button matTooltip="Reload" (click)="loadPendingUsers()"
                        [disabled]="loadingPending">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
                <p class="section-desc">
                    Users who have been invited but have not yet completed registration.
                    Invite links expire after 48 hours — resend to generate a fresh link.
                </p>

                <div class="loading-wrapper" *ngIf="loadingPending">
                    <mat-spinner diameter="36"></mat-spinner>
                </div>

                <div class="table-wrapper" *ngIf="!loadingPending">
                    <table class="perm-grid ticket-table">
                        <thead>
                            <tr>
                                <th class="perm-grid__user-col">Email</th>
                                <th>Invited</th>
                                <th style="width:100%;"></th>
                                <th style="text-align:right; white-space:nowrap;">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let user of pendingUsers" class="perm-grid__row">
                                <td class="perm-grid__user-cell">
                                    <div class="perm-grid__user-info">
                                        <div class="avatar">{{ user.usr_MAIL?.charAt(0).toUpperCase() }}</div>
                                        <div class="perm-grid__user-details">
                                            <span class="perm-grid__user-name">{{ user.usr_MAIL }}</span>
                                            <span class="perm-grid__user-mail perm-tag perm-tag--pending">Pending</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="perm-grid__user-cell"
                                    style="opacity:0.55; font-size:0.8rem; white-space:nowrap;">
                                    {{ user.createdAt | date:'medium' }}
                                </td>
                                <td style="width:100%;"></td>
                                <td class="perm-grid__user-cell" style="text-align:right; white-space:nowrap;">
                                    <button mat-icon-button matTooltip="Resend invite" (click)="resendInvite(user)"
                                        [disabled]="resendingId === user.id">
                                        <mat-spinner *ngIf="resendingId === user.id" diameter="18"
                                            style="display:inline-flex;"></mat-spinner>
                                        <mat-icon *ngIf="resendingId !== user.id">forward_to_inbox</mat-icon>
                                    </button>
                                    <button mat-icon-button matTooltip="Cancel invitation" class="delete-btn"
                                        (click)="deletePendingUser(user)">
                                        <mat-icon>delete_outline</mat-icon>
                                    </button>
                                </td>
                            </tr>

                        </tbody>

                    </table>
                    <div *ngIf="pendingUsers.length === 0" style="width: 100%; padding: 1.5rem 0;">
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <mat-icon color="primary"
                                style="transform:scale(2); margin-bottom:10px;">mark_email_read</mat-icon>
                            <div>No pending invitations</div>
                        </div>
                    </div>
                </div>

            </div>
        </mat-tab>

    </mat-tab-group>

</div>